<template>
<div>
    <div class="mt-1 relative">

        <!-- label -->
        <label class="block text-sm font-medium text-gray-600">{{label}}

        <!-- selection box -->
        <select
            v-model="selection"
            :disabled="disabled" class="bg-gray-50 text-sm text-gray-800 pl-2 pr-2 py-3 block w-full border border-gray-300 focus:outline-none rounded-lg"
            :class="showError ?
				'border-2 border-red-600 focus:ring-red-500 focus:border-red-500' :
				'focus:ring-blue-500 focus:border-blue-500'">
            
            <!-- placeholder -->
            <option v-if="placeholder" disabled>
                {{placeholder}}
            </option>

            <!-- options -->
            <option v-for="(option, index) in options" :value="option.id" :key="index">
                {{option.text}}
            </option>
        </select>
        </label>
    </div>

    <!-- error text -->
    <p v-if="showError" class="text-sm font-medium text-red-700 whitespace-normal">{{error}}</p>
</div>
    
</template>

<script>
export default {
    name: "CustomSelect",
	components: {
	},
    props: {
        label: String,
        placeholder: String,
        options: Array,
        preSelect: String,
        reset: Boolean,
        disabled: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            default: ""
        },
		light: Boolean,
		showToolTip: {
			type: Boolean,
			default: false
		},
		toolTipHeader: String,
		toolTipBody: String
    },
    data() {
        return {
            selection: ""
        }
    },
    computed: {
        showError() {
          if (this.error.length > 0) return true;
          return false;
        },
        model: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit('update:modelValue', value);
        }
      }
    },
    watch: {
        selection: function(value) {
            this.setValue(value);
        },
        preSelect: function(value) {
            this.selection = value;
        },
        reset: function() {
            this.selection = ""
        }
    },
    methods: {
        setValue(value) {
            this.$emit('update:modelValue', value);
        }
    },
	mounted() {
        if (this.preSelect !== undefined) {
    this.selection = this.preSelect;
  }		
	}

}
</script>